<template>
  <div ref="quantidadeContasMesChart" @update-charts="update" />
</template>

<script>
import ApexCharts from 'apexcharts';
import { i18n } from '@/modules/localization/index.js';
import eventbus from '@/modules/core/services/eventbus';
import estatisticasChartsDefaultOptions from './estatisticasChartsDefaultOptions';
export default {
  props: {
    loading: { type: Boolean, required: true },
  },
  data: () => ({
    quantidadeContasMesChart: null,
    options: estatisticasChartsDefaultOptions,
  }),
  mounted() {
    this.quantidadeContasMesChart = new ApexCharts(this.$refs.quantidadeContasMesChart, this.options);
    this.quantidadeContasMesChart.render();
    eventbus.on('update-charts', this.update);
  },
  unmounted() {
    this.quantidadeContasMesChart.destroy();
    eventbus.off('update-charts', this.update);
  },
  methods: {
    async update(chartsData) {
      const x = chartsData.quantidadeContasMes.map((x) => x.mesAno);
      const y = chartsData.quantidadeContasMes.map((x) => x.quantidade);
      this.quantidadeContasMesChart.updateOptions({
        chart: {
          type: 'area',
        },
        title: {
          text: i18n.global.t('quantidadeContasMes'),
        },
        subtitle: {
          text: i18n.global.t('media') + chartsData.mediaContasMes,
        },
        series: [{ data: y }],
        xaxis: { categories: x },
      });
    },
  },
};
</script>
